module.exports = __webpack_public_path__ + "arrow-slide-prev.png?8567f46276877bc0bdfa0a92c4e4ff7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-slide-prev.png
// module id = 159
// module chunks = 0